import Constants from '../config/constants';
import QRCode from 'qrcode';

export const doFetch = async (url, options) => {
    const response = await fetch(url, options);

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    return await response.json();
};

export const base64ToByteArray = (str) => {
    const decodedStr = atob(str);
    const arr = new Uint8Array(decodedStr.length);

    for (let i = 0; i < decodedStr.length; i++) {
        arr[i] = decodedStr.charCodeAt(i);
    }

    return arr;
}

export const dataToChunks = (data, maxElementsPerRequest = 0) => {
    return data
        .filter(n => n)
        .reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index / (maxElementsPerRequest > 0 ? maxElementsPerRequest:Constants.MAX_ELEMENTS_PER_REQUEST))

            if (!resultArray[chunkIndex]) {
                resultArray[chunkIndex] = [] // start a new chunk
            }

            resultArray[chunkIndex].push(item);

            return resultArray
        }, []);
};

export const toHeaders = (auth) => {
    return {
        "Content-Type": Constants.CONTENT_TYPE_JSON,
        "Authorization": `Bearer ${auth.userData.access_token}`
    }
}

export const digest = async (input) => {
    const textAsBuffer = new TextEncoder().encode(input);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray
        .map((item) => item.toString(16).padStart(2, "0"))
        .join("");
};

export const checkBit = (num, v) =>
    num & (1 << Math.log2(v));

export const qrcode = async (url, width = 500, height = 500) => {
    const qr = await QRCode.toDataURL(url, {
        width: width,
        height: height,
        color: {
            dark: '#000',
            light: '#0000'
        }
    });
    return qr.split('base64,')[1];
}

export const generateShortCode = () =>
    (Math.random() + 1).toString(36).substring(5);

export const resolveColumnLineIndex = (columns, firstRow) => {
    let data = CSVToArray(firstRow)[0];
    return columns
        .map(d => {
            return {
                label: d.label,
                dataKey: d.dataKey,
                index: data.findIndex(e => e.toLowerCase() === d.label.toLowerCase()),
            };
        })
        .filter(d => d.index > -1);
}

export const CSVToArray = (str) => {
    const arr = [];
    let quote = false;  // 'true' means we're inside a quoted field

    // Iterate over each character, keep track of current row and column (of the returned array)
    for (let row = 0, col = 0, c = 0; c < str.length; c++) {
        let cc = str[c], nc = str[c + 1];        // Current character, next character
        arr[row] = arr[row] || [];             // Create a new row if necessary
        arr[row][col] = arr[row][col] || '';   // Create a new column (start with empty string) if necessary

        // If the current character is a quotation mark, and we're inside a
        // quoted field, and the next character is also a quotation mark,
        // add a quotation mark to the current column and skip the next character
        if (cc === '"' && quote && nc === '"') { arr[row][col] += cc; ++c; continue; }

        // If it's just one quotation mark, begin/end quoted field
        if (cc === '"') { quote = !quote; continue; }

        // If it's a comma and we're not in a quoted field, move on to the next column
        if (cc === ',' && !quote) { ++col; continue; }

        // If it's a newline (CRLF) and we're not in a quoted field, skip the next character
        // and move on to the next row and move to column 0 of that new row
        if (cc === '\r' && nc === '\n' && !quote) { ++row; col = 0; ++c; continue; }

        // If it's a newline (LF or CR) and we're not in a quoted field,
        // move on to the next row and move to column 0 of that new row
        if (cc === '\n' && !quote) { ++row; col = 0; continue; }
        if (cc === '\r' && !quote) { ++row; col = 0; continue; }

        // Otherwise, append the current character to the current column
        arr[row][col] += cc;
    }
    return arr;
}